export default __webpack_public_path__ + "static/media/ic_new_link_16.d260d205.svg";